export const StateCodes = {
  OHIO: "10",
  NORTH_CAROLINA: "20",
  NEW_JERSEY: "30",
  PENNSYLVANIA: "40",
  ALABAMA: "50",
  ALASKA: "51",
  ARIZONA: "52",
  ARKANSAS: "53",
  CALIFORNIA: "54",
  COLORADO: "55",
  CONNECTICUT: "56",
  DELAWARE: "57",
  FLORIDA: "58",
  GEORGIA: "59",
  HAWAII: "60",
  IDAHO: "61",
  ILLINOIS: "62",
  INDIANA: "63",
  IOWA: "64",
  KANSAS: "65",
  KENTUCKY: "66",
  LOUISIANA: "67",
  MAINE: "68",
  MARYLAND: "69",
  MASSACHUSETTS: "70",
  MICHIGAN: "71",
  MINNESOTA: "72",
  MISSISSIPPI: "73",
  MISSOURI: "74",
  MONTANA: "75",
  NEBRASKA: "76",
  NEVADA: "77",
  NEW_HAMPSHIRE: "78",
  NEW_MEXICO: "79",
  NEW_YORK: "80",
  NORTH_DAKOTA: "81",
  OKLAHOMA: "82",
  OREGON: "83",
  RHODE_ISLAND: "84",
  SOUTH_CAROLINA: "85",
  SOUTH_DAKOTA: "86",
  TENNESSEE: "87",
  TEXAS: "88",
  UTAH: "89",
  VERMONT: "90",
  VIRGINIA: "91",
  WASHINGTON: "92",
  WEST_VIRGINIA: "93",
  WISCONSIN: "94",
  WYOMING: "95",
};

export const states = [
  { value: "Alabama", code: StateCodes.ALABAMA },
  { value: "Alaska", code: StateCodes.ALASKA },
  { value: "Arizona", code: StateCodes.ARIZONA },
  { value: "Arkansas", code: StateCodes.ARKANSAS },
  { value: "California", code: StateCodes.CALIFORNIA },
  { value: "Colorado", code: StateCodes.COLORADO },
  { value: "Connecticut", code: StateCodes.CONNECTICUT },
  { value: "Delaware", code: StateCodes.DELAWARE },
  { value: "Florida", code: StateCodes.FLORIDA },
  { value: "Georgia", code: StateCodes.GEORGIA },
  { value: "Hawaii", code: StateCodes.HAWAII },
  { value: "Idaho", code: StateCodes.IDAHO },
  { value: "Illinois", code: StateCodes.ILLINOIS },
  { value: "Indiana", code: StateCodes.INDIANA },
  { value: "Iowa", code: StateCodes.IOWA },
  { value: "Kansas", code: StateCodes.KANSAS },
  { value: "Kentucky", code: StateCodes.KENTUCKY },
  { value: "Louisiana", code: StateCodes.LOUISIANA },
  { value: "Maine", code: StateCodes.MAINE },
  { value: "Maryland", code: StateCodes.MARYLAND },
  { value: "Massachusetts", code: StateCodes.MASSACHUSETTS },
  { value: "Michigan", code: StateCodes.MICHIGAN },
  { value: "Minnesota", code: StateCodes.MINNESOTA },
  { value: "Mississippi", code: StateCodes.MISSISSIPPI },
  { value: "Missouri", code: StateCodes.MISSOURI },
  { value: "Montana", code: StateCodes.MONTANA },
  { value: "Nebraska", code: StateCodes.NEBRASKA },
  { value: "Nevada", code: StateCodes.NEVADA },
  { value: "New Hampshire", code: StateCodes.NEW_HAMPSHIRE },
  { value: "New Jersey", code: StateCodes.NEW_JERSEY },
  { value: "New Mexico", code: StateCodes.NEW_MEXICO },
  { value: "New York", code: StateCodes.NEW_YORK },
  { value: "North Carolina", code: StateCodes.NORTH_CAROLINA },
  { value: "North Dakota", code: StateCodes.NORTH_DAKOTA },
  { value: "Ohio", code: StateCodes.OHIO },
  { value: "Oklahoma", code: StateCodes.OKLAHOMA },
  { value: "Oregon", code: StateCodes.OREGON },
  { value: "Pennsylvania", code: StateCodes.PENNSYLVANIA },
  { value: "Rhode Island", code: StateCodes.RHODE_ISLAND },
  { value: "South Carolina", code: StateCodes.SOUTH_CAROLINA },
  { value: "South Dakota", code: StateCodes.SOUTH_DAKOTA },
  { value: "Tennessee", code: StateCodes.TENNESSEE },
  { value: "Texas", code: StateCodes.TEXAS },
  { value: "Utah", code: StateCodes.UTAH },
  { value: "Vermont", code: StateCodes.VERMONT },
  { value: "Virginia", code: StateCodes.VIRGINIA },
  { value: "Washington", code: StateCodes.WASHINGTON },
  { value: "West Virginia", code: StateCodes.WEST_VIRGINIA },
  { value: "Wisconsin", code: StateCodes.WISCONSIN },
  { value: "Wyoming", code: StateCodes.WYOMING },
];

export const getStatesWithCombinedValue = () => {
  return states.map((state) => ({
    ...state,
    value: `${state.value} (${state.code})`,
  }));
};
